export const SOS_LOGO_URL = "/sos-logo.png"; // white text variant for dark UI
export const SOS_LOGO_DARK_URL =
  "https://customer-assets.emergentagent.com/job_southern-quotes/artifacts/9nggjiob_SOS.png"; // original (dark text) for white backgrounds

export function Logo({ className = "h-8 w-auto", showWordmark = true }) {
  return (
    <div className={`flex items-center gap-3 ${showWordmark ? "" : ""}`} data-testid="sos-logo">
      <img src={SOS_LOGO_URL} alt="Southern Ocean Solutions" className={className} />
      {showWordmark && (
        <div className="leading-tight">
          <div className="font-display text-sm font-semibold tracking-wide text-[#011836]">
            SOUTHERN <span className="text-[#0088CC]">OCEAN</span>
          </div>
          <div className="font-display text-[10px] uppercase tracking-[0.25em] text-[#5B6B7C]">
            Solutions
          </div>
        </div>
      )}
    </div>
  );
}
